import React, { useEffect } from 'react';
import { Dispatch } from "redux";
import { useDispatch } from 'react-redux';
import { resetHeader, setHeader } from '../../store/main';
import headerConfigs from '../../services/headerConfig';
import DashboardStatisticsHeader from '../../components/DashboardHeader';
import TopClients from '../../components/DashboardTopClients';
import TopArtists from '../../components/DashboardTopArtists';
import RevenuGraph from '../../components/RevenuGraph';
import RevenueCard from '../../components/Revenu';
import Activity from '../../components/DashboardActivity'
import ActivityGraph from '../../components/ActivityGraph';
import {  Statistic, Card, Row, Col } from 'antd'


const Dashboard = () => {
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    dispatch(setHeader(headerConfigs.dashboard()));

    return () => {
      dispatch(resetHeader());
    };
  }, [dispatch]);
  
  return (
    <div className="dashboard">
      <DashboardStatisticsHeader />
      <Row gutter={24}>
        <Col span={6}>
          <TopClients />
          <TopArtists />
        </Col>
        <Col span={12}>
          <RevenuGraph />
          <ActivityGraph />
        </Col>
        <Col span={6}>
          <RevenueCard />
          <Activity />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
